import { c as _c } from "react/compiler-runtime";
import { CICType } from "@/entities/IProfile";
const CIC_COLOR: Record<CICType, string> = {
  [CICType.INACCURATE]: "tw-bg-[#F97066]",
  [CICType.UNKNOWN]: "tw-bg-[#FEDF89]",
  [CICType.PROBABLY_ACCURATE]: "tw-bg-[#AAF0C4]",
  [CICType.ACCURATE]: "tw-bg-[#73E2A3]",
  [CICType.HIGHLY_ACCURATE]: "tw-bg-[#3CCB7F]"
};
export enum ProfileLevelSize {
  SMALL = "SMALL",
  MEDIUM = "MEDIUM",
  LARGE = "LARGE",
  XLARGE = "XLARGE",
}
const LEVEL_SIZE_CLASSES: Record<ProfileLevelSize, string> = {
  [ProfileLevelSize.SMALL]: "tw-h-4 tw-w-4 tw-text-[9px]",
  [ProfileLevelSize.MEDIUM]: "tw-h-5 tw-w-5 tw-text-[0.625rem]",
  [ProfileLevelSize.LARGE]: "tw-h-6 tw-w-6 tw-text-[0.75rem]",
  [ProfileLevelSize.XLARGE]: "tw-h-8 tw-w-8 tw-text-[1rem]"
};
const CIC_SIZE_CLASSES: Record<ProfileLevelSize, string> = {
  [ProfileLevelSize.SMALL]: "-tw-top-[0.1875rem] tw-h-2 tw-w-2",
  [ProfileLevelSize.MEDIUM]: "-tw-top-1 tw-h-2 tw-w-2",
  [ProfileLevelSize.LARGE]: "-tw-top-1.5 tw-h-3 tw-w-3",
  [ProfileLevelSize.XLARGE]: "-tw-top-2 tw-h-4 tw-w-4"
};
const TEXT_COLOR_CLASSES = {
  "iron-50": "tw-text-iron-50",
  "iron-300": "tw-text-iron-300",
  black: "tw-text-black"
} as const;
type LevelTextColor = keyof typeof TEXT_COLOR_CLASSES;
interface ProfileLevelProps {
  readonly level: number;
  readonly cicType: CICType;
  readonly color?: LevelTextColor | undefined;
  readonly size?: ProfileLevelSize | undefined;
}
export default function ProfileLevel(t0) {
  const $ = _c(8);
  const {
    level,
    cicType,
    color,
    size: t1
  } = t0;
  const size = t1 === undefined ? ProfileLevelSize.MEDIUM : t1;
  const mainColorClass = TEXT_COLOR_CLASSES[color ?? "iron-300"] ?? TEXT_COLOR_CLASSES["iron-300"];
  const t2 = `${LEVEL_SIZE_CLASSES[size]} tw-flex tw-items-center tw-justify-center tw-rounded-full tw-bg-gradient-to-br tw-from-iron-800 tw-to-iron-900 tw-font-bold tw-leading-3 tw-ring-1 tw-ring-inset tw-ring-iron-700 ${mainColorClass}`;
  let t3;
  if ($[0] !== level || $[1] !== t2) {
    t3 = <div className={t2}>{level}</div>;
    $[0] = level;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = `${CIC_SIZE_CLASSES[size]} ${CIC_COLOR[cicType]} tw-absolute -tw-right-1 tw-block tw-flex-shrink-0 tw-rounded-full`;
  let t5;
  if ($[3] !== t4) {
    t5 = <span className={t4} />;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== t3 || $[6] !== t5) {
    t6 = <div className="tw-relative">{t3}{t5}</div>;
    $[5] = t3;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  return t6;
}